import { render, staticRenderFns } from "./AddClient.vue?vue&type=template&id=44ffeb27"
import script from "./AddClient.vue?vue&type=script&lang=js"
export * from "./AddClient.vue?vue&type=script&lang=js"
import style0 from "./AddClient.vue?vue&type=style&index=0&id=44ffeb27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports